"use strict";

define('view/message.template.editor',['marionette', 'uikit/uikit', './text.editor', 'templates'], function (Mn, UIKit, TextEditor, Templates) {
  var MessageTemplateEditor = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    template: Templates.IRB['message.template.editor'],
    useInjector: true,
    options: {
      recipientsVisible: true,
      bccVisible: false,
      ccVisible: false,
      subjectVisible: false,
      richText: null,
      contentInput: null,
      containerStyle: 'position: relative; padding-top: 1em;',
      toolbarStyle: 'position: absolute; top: 0; right: 0; z-index: 2;',
      imagePluginEnabled: true,
      macroPluginEnabled: true
    },
    update: {
      recipientsVisible: false,
      bccVisible: false,
      ccVisible: false,
      subjectVisible: false,
      richText: false,
      contentInput: false,
      macroPluginEnabled: false,
      imagePluginEnabled: false
    },
    ui: {
      'formContainer': '.form-container'
    },
    initialize: function initialize() {
      UIKit.ComponentMixin.initialize.apply(this, arguments);
      this.recipientsTokenInput = new UIKit.TokenInput({
        name: 'recipients',
        placeholder: ''
      });
      this.ccTokenInput = new UIKit.TokenInput({
        name: 'cc',
        placeholder: ''
      });
      this.bccTokenInput = new UIKit.TokenInput({
        name: 'bcc',
        placeholder: ''
      });
      this.subjectInput = new UIKit.TagInput({
        name: 'subject',
        searchStartCharCode: 219
      });
      this.configureForm();
      this.onModelChange();
    },
    buildRedactorOptions: function buildRedactorOptions() {
      var plugins = ['disabled'],
        ignorePlugins = [];
      if (this.macroPluginEnabled) {
        plugins.push('macro');
      }
      if (!this.imagePluginEnabled) {
        ignorePlugins.push('imageEmbed', 'imageLoading');
      }
      return _.extend({
        name: 'content',
        ignorePlugins: ignorePlugins,
        plugins: plugins,
        macros: null
      }, this.getOption('redactorOptions'));
    },
    configureForm: function configureForm() {
      var form = this.form;
      var subjectText = new Handlebars.SafeString('Subject:' + Array(4).join('&nbsp;') + '<br>' + this.createTagTipText());
      form.addField({
        width: 16,
        text: 'To:'
      }, this.recipientsTokenInput);
      form.addField({
        width: 16,
        text: 'CC:'
      }, this.ccTokenInput);
      form.addField({
        width: 16,
        text: 'BCC:'
      }, this.bccTokenInput);
      form.addField({
        width: 16,
        text: subjectText
      }, this.subjectInput);
    },
    createTagTipText: function createTagTipText() {
      return '<span style="color: rgba(0, 0, 0, 0.5);">Type "[" to begin tag search</span>';
    },
    toggleBcc: function toggleBcc() {
      return this.bccVisible = !this.bccVisible;
    },
    toggleCc: function toggleCc() {
      this.ccVisible = !this.ccVisible;
      return this;
    },
    onModelChange: function onModelChange() {
      this.form.model = this.model;
    },
    onChangeRichText: function onChangeRichText() {
      var options = {
        width: 16
      };
      if (this.contentField) {
        this.form.removeView(this.contentField);
        this.contentField.destroy();
      }
      if (this.richText) {
        this.contentInput = new TextEditor(this.buildRedactorOptions());
      } else {
        this.contentInput = new UIKit.TagInput({
          name: 'content',
          searchStartCharCode: 219
        });
        options.text = new Handlebars.SafeString('Content:' + Array(4).join('&nbsp;') + '<br>' + this.createTagTipText());
      }
      this.contentField = this.form.addField(options, this.contentInput);
    },
    updateAttributes: function updateAttributes() {
      if (this.ccButton.visible || this.bccButton.visible) {
        this.ui.formContainer.attr('style', this.containerStyle);
      } else {
        this.ui.formContainer.attr('style', '');
      }
      this.recipientsTokenInput.getOption('parent').visible = this.recipientsVisible;
      this.subjectInput.getOption('parent').visible = this.subjectVisible;
      this.ccTokenInput.getOption('parent').visible = this.ccVisible;
      this.bccTokenInput.getOption('parent').visible = this.bccVisible;
    }
  });
  return MessageTemplateEditor;
});

